import { Link } from 'react-router-dom';
import Arrow from '../../../components/ui/Arrow';
import { localizedPath, useLocale, useMessages } from '../../../i18n/locale';
import FadeInOnScroll from '../../../components/effects/FadeInOnScroll';
import BlurText from '../../../components/effects/BlurText';

export default function CommunitySection() {
  const locale = useLocale();
  const copy = useMessages().home.community;
  return (
    <section id="community" className="community-section section-pad">
      <div className="container">
        <div className="community-layout">
          <FadeInOnScroll className="community-copy">
            <h2>
              <BlurText text={copy.title[0]} />
              <br />
              <BlurText text={copy.title[1]} className="muted-heading" delay={140} />
            </h2>
            <p>{copy.description}</p>
            <Link className="text-link" to={localizedPath(locale, '/community')}>
              {copy.explore} <Arrow />
            </Link>
          </FadeInOnScroll>
          <FadeInOnScroll className="community-network" aria-hidden="true" delay={100}>
            <div className="community-network__grid" />
            <svg viewBox="0 0 500 360" fill="none" preserveAspectRatio="xMidYMid meet">
              <path d="M75 259 151 110 255 180 380 72 429 253 255 180 336 311 75 259 151 110" />
              <path
                d="M151 110 380 72M75 259 255 180 429 253M255 180 336 311"
                className="network-muted"
              />
              {[
                [75, 259],
                [151, 110],
                [255, 180],
                [380, 72],
                [429, 253],
                [336, 311],
              ].map(([x, y], index) => (
                <g key={`${x}-${y}`}>
                  <circle cx={x} cy={y} r={index === 2 ? 20 : 10} className="network-halo" />
                  <circle cx={x} cy={y} r={index === 2 ? 5 : 3} className="network-dot" />
                </g>
              ))}
            </svg>
            <span className="network-label network-label--one">{copy.network[0]}</span>
            <span className="network-label network-label--two">{copy.network[1]}</span>
            <span className="network-label network-label--three">{copy.network[2]}</span>
          </FadeInOnScroll>
        </div>
        <div className="community-tracks">
          {copy.tracks.map((track) => (
            <div key={track.title}>
              <h3>{track.title}</h3>
              <p>{track.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
